var map = {
	"./ec2-check/reducers": 1057,
	"./ec2-status-change/reducers": 1058,
	"./endpoint/reducers": 1059,
	"./group/reducers": 1060,
	"./instrument-template/reducers": 1061,
	"./rds-status/reducers": 1062,
	"./sqs-depth/reducers": 1063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1056;